import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function IcecreamIcon(props: IconProps) {
    return <Icon {...props} iconKey={"icecream"}/>
}
